import { CaseAssetItem } from '../../types';
import { callExternalApi, CallResult } from '../callExternalApi';

export async function fetchCaseAssets(caseId: string): Promise<CallResult<CaseAssetItem[]>> {
  if (!caseId) return { data: null, error: { message: 'Must provide case ID to fetch case assets' } };

  return await callExternalApi<CaseAssetItem[]>({
    url: `api/cases/${caseId}/assets`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
}
